enum PlayerViewMode {
  FULL_SCREEN = 'FULL_SCREEN',
  WINDOW = 'WINDOW'
}

export default PlayerViewMode;
